 
  export class AdminEntity {
    userId: any;
    // username: any;
    password: any;
    firstname: any;
    lastname: any;
    phone: any;
    email: any;
    status: any;
    usertype: any;
  }